export const initialState = {
  attributes: {},
  alert: null,
  city: {},
  user: {}
};

export const reducer = (action, state) => {
  switch (action.type) {
    case "UPDATE_CATEGORIES":
      return { ...state, attributes: action.payload };
    case "UPDATE_ALERT":
      return { ...state, alert: action.payload };
    case "UPDATE_CITY":
      return { ...state, city: action.payload };
    case "UPDATE_USER":
      return { ...state, user: action.payload };

    default:
      return state;
  }
};

export default function mapDispatchToProps(dispatch) {
  return {
    updateAttributes: payload =>
      dispatch({ type: "UPDATE_CATEGORIES", payload }),
    updateAlert: payload => dispatch({ type: "UPDATE_ALERT", payload }),
    updateCity: payload => dispatch({ type: "UPDATE_CITY", payload }),
    updateUser: payload => dispatch({ type: "UPDATE_USER", payload })
  };
}
